<template>
	<transition name="modal-fade">
		<div class="modal-backdrop" @click.self="close">
			<div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">

				<section class="modal-body" id="modalDescription">
					<slot name="body">
					</slot>
				</section>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'ModalEdit',
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10;

	.modal {
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 1px 1px 10px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
		width: 100%;
		height: 100vh;
		margin: 0 auto;

		.modal-footer {
			padding: 20px;
			display: flex;
		}

		.modal-footer {
			justify-content: center;
			width: 100%;

			button {
				padding: 0 10px;
			}
		}

		.modal-body {
			position: relative;
			padding: 30px 10px 20px;
			color: $main-color;
			text-align: center;
			font-size: 1.3em;
			margin: 0 auto;
			width: 684px;
		}
  }
}

.modal-fade-enter,
.modal-fade-leave-active {
	opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity .5s ease
}
</style>
